import "@reach/tooltip/styles.css"
import React from "react"
import Portal from "@reach/portal"
import { useTooltip, TooltipPopup } from "@reach/tooltip"
import { useTheme } from "../theme"

// Center the tooltip, but collisions will win
function centered(triggerRect, tooltipRect) {
  const triggerCenter = triggerRect.left + triggerRect.width / 2
  const left = triggerCenter - tooltipRect.width / 2
  const maxLeft = window.innerWidth - tooltipRect.width - 2
  return {
    left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
    top: triggerRect.bottom + 8 + window.scrollY
  }
}

export default function Tooltip({ children, label, ariaLabel }) {
  const { theme } = useTheme()

  // get the props from useTooltip
  const [trigger, tooltip] = useTooltip()

  // destructure off what we need to position the triangle
  const { isVisible, triggerRect } = tooltip

  return (
    <>
      {React.cloneElement(children, trigger)}
      {isVisible && (
        // The Triangle. We position it relative to the trigger, not the popup
        // so that collisions don't have a triangle pointing off to nowhere.
        // Using a Portal may seem a little extreme, but we can keep the
        // positioning logic simpler here instead of needing to consider
        // the popup's position relative to the trigger and collisions
        <Portal>
          <div
            style={{
              zIndex: 9000,
              position: "absolute",
              left:
                triggerRect && triggerRect.left - 10 + triggerRect.width / 2,
              top: triggerRect && triggerRect.bottom + window.scrollY,
              width: 0,
              height: 0,
              borderLeft: "10px solid transparent",
              borderRight: "10px solid transparent",
              borderBottom: "10px solid " + theme.accentText
            }}
          />
        </Portal>
      )}
      <TooltipPopup
        {...tooltip}
        label={label}
        ariaLabel={ariaLabel}
        style={{
          zIndex: 9000,
          background: theme.accentText,
          color: theme.backgroundColor,
          border: "none",
          borderRadius: 3,
          padding: "0.5em 1em",
          maxWidth: "22rem",
          whiteSpace: "normal"
        }}
        position={centered}
      />
    </>
  )
}
